import React, {useEffect, useState} from "react";
import axios from "axios";
import {useTranslation} from "react-i18next";
import {Avatar, Button, Divider, Radio, Space, Table} from "antd";
import {Link} from "react-router-dom";
import {divide1toPct, handleRank, setKey} from "../util/util";
import Icon from "./Icon";
import UserOutlined from "@ant-design/icons/lib/icons/UserOutlined";
import Search from "antd/es/input/Search";
import AimOutlined from "@ant-design/icons/lib/icons/AimOutlined";

export default (prop) => {

    const {t} = useTranslation()
    const [loading, setLoading] = useState(false)
    const [data0, setData0] = useState([])
    const [data, setData] = useState([])
    const [value, setValue] = useState("")
    const [only, setOnly] = useState(false)


    const columns = [
        {
            key: 'player',
            dataIndex: 'player',
            title: t('players'),
            render: (_, p) =>
                <Link to={`/player/${p.handle}`} >
                <Space>
                {
                    p.pfp > 0 ? <Avatar src={`https://www.aslucky.club/file/touhou/pfp/${p.handle}.png?r=${p.pfp}`} shape="square" size={32} icon={<UserOutlined />} />
                        : <Avatar shape="square" size={32} icon={<UserOutlined />} />
                }
                <span>{p.clanTag ? `<${p.clanTag}>` : ''}{p.name}</span>
            </Space>
                </Link>,
            align: 'left',
            width: 300
        },
        {
            key: 'allyTotal',
            dataIndex: 'allyTotal',
            title: t('friends.allyTotal'),
            align: 'center',
            // sorter: (a, b) => a.allyTotal - b.allyTotal
        },
        {
            key: 'allyWinRate',
            dataIndex: 'allyWinRate',
            title: t('friends.allyWinRate'),
            render: (_, p) => <span>{p.allyWinRate}%</span>,
            align: 'center',
            // sorter: (a, b) => a.allyWinRate - b.allyWinRate
        },
        {
            key: 'enemyTotal',
            dataIndex: 'enemyTotal',
            title: t('friends.enemyTotal'),
            align: 'center',
            // sorter: (a, b) => a.enemyTotal - b.enemyTotal
        },
        {
            key: 'enemyWinRate',
            dataIndex: 'enemyWinRate',
            title: t('friends.enemyWinRate'),
            render: (_, p) => <span>{p.enemyWinRate}%</span>,
            align: 'center',
            // sorter: (a, b) => a.enemyWinRate - b.enemyWinRate
        },
        {
            key: 'captain',
            dataIndex: 'captain',
            title: t('friends.captain'),
            render: (_, p) => <span>{p.captainWin}-{p.captainLose}</span>,
            align: 'center',
            // sorter: (a, b) => a.enemyWinRate - b.enemyWinRate
        },
    ]

    useEffect(() => {
        setLoading(true)
        axios.get(`player/together/${prop.player.handle}`).then(data => {
            for (const i of data) {
                i.allyTotal = i.allyWin + i.allyLose
                i.enemyTotal = i.enemyWin + i.enemyLose
                i.allyWinRate = divide1toPct(i.allyWin,i.allyTotal)
                i.enemyWinRate = divide1toPct(i.enemyWin,i.enemyTotal)
            }
            data.sort((a, b) => b.allyTotal - a.allyTotal)
            setKey(data, 'handle')
            setData0(data)
            setData(data.slice(0, 50))
            setLoading(false)
        })
    }, [prop.player.handle])

    return <Space direction={'vertical'} size={30}>

        <Space>
            <Search value={value} onSearch={() => {
                if (!value) {
                    setData(data0.slice(0, 50))
                    return
                }

                let t = data0.filter(item => item.name.indexOf(value) > -1 || item.clanTag.indexOf(value) > -1 || item.handle.indexOf(value) > -1)
                setData(t.slice(0, 50))
            }} onChange={(e) => setValue(e.target.value) } enterButton />
            <Button onClick={() => {
                setOnly(!only)
                let t = data0
                if (!only) {
                    t = data0.filter(item => item.captainWin !== 0 || item.captainLose !== 0)
                    t.sort((a, b) => {
                        return a.captainWin / (a.captainWin + a.captainLose) - b.captainWin / (b.captainWin + b.captainLose)
                    })
                }
                setData(t.slice(0, 50))
            }} type="primary" shape="circle" icon={<AimOutlined />} />
        </Space>
        <Table size={'small'} style={{ width: "660px" }} columns={columns} pagination={false} dataSource={data} loading={loading}/>
    </Space>
}
